import React from 'react'

const ResultStudentTerm2 = () => {
  return (
    <div>ResultStudentTerm2</div>
  )
}

export default ResultStudentTerm2